import intercom from '../core/intercom'
import {DEHYDRATE_KEY as UI_DEHYDRATE_KEY, uiActors} from '../core/redux/ui'
import ticketActors, {DEHYDRATE_KEY as TICKET_DEHYDRATE_KEY} from '../ticket/actors'
import companyActors from '../company/actors'
import providerActors from '../provider/actors'
import patrimonyActors from '../patrimony/actors'
import userActors from '../user/actors'
import workflowActors from '../workflow/actors'
import referenceActors from '../reference/actors'
import config from '../config'

export const DEHYDRATE_KEYS = [UI_DEHYDRATE_KEY, TICKET_DEHYDRATE_KEY]

function subDomainAuthenticatedUpdated() {
    var authenticated

    return (state, dispatch) => {
        const nextAuthenticated = state.user.authenticated

        if (nextAuthenticated != authenticated) {
            const domainChunks = window.location.host.split('.')

            if (domainChunks.length == 3) {
                const locationSubDomain = domainChunks[0]
                const userSubDomain = nextAuthenticated && nextAuthenticated.frontUriPrefix

                if (userSubDomain && userSubDomain != locationSubDomain) {
                    // redirect to user subdomain
                    const nextLocationHref = window.location.href.replace('//' + locationSubDomain + '.', '//' + userSubDomain + '.')
                    window.location.href = nextLocationHref
                }
            }
            authenticated = nextAuthenticated
        }
    }
}

function intercomAuthenticatedUpdated() {
    var authenticated

    return (state, dispatch) => {
        const nextAuthenticated = state.user.authenticated

        if (nextAuthenticated != authenticated) {
            if (nextAuthenticated) {
                intercom('boot', {
                    app_id: config.intercom.appId,
                    user_id: nextAuthenticated.uid,
                    email: nextAuthenticated.login,
                    name: [nextAuthenticated.firstName, nextAuthenticated.lastName].join(' '),
                    company: nextAuthenticated.company && {
                        id: nextAuthenticated.company.uid,
                        name: nextAuthenticated.company.label
                    }
                })
            } else {
                intercom('shutdown')
            }
            authenticated = nextAuthenticated
        }
    }
}

function intercomLocationUpdated() {
    var location
    var timer

    return (state, dispatch) => {
        const nextLocation = state.router.location

        if (nextLocation != location) {
            if (nextLocation.pathname != (location && location.pathname)) {
                clearTimeout(timer)
                timer = setTimeout(() => {
                    // wait for redirects
                    intercom('update')
                }, 500)
            }
            location = nextLocation
        }
    }
}

function autoloadVersionUpdated() {
    var version
    var location
    var triggerAutoReload = false

    return (state, dispatch) => {
        const nextVersion = state.app.version
        const nextLocation = state.router.location

        if (nextVersion != version) {
            if (version) {
                triggerAutoReload = true
            }
            version = nextVersion
        }

        if (nextLocation != location) {
            if (triggerAutoReload) {
                if (nextLocation.pathname != (location && location.pathname)) {
                    // autoreload
                    triggerAutoReload = false
                    window.location = nextLocation.pathname
                }
            }
            location = nextLocation
        }
    }
}

export default [
    subDomainAuthenticatedUpdated(),
    intercomAuthenticatedUpdated(),
    intercomLocationUpdated(),
    autoloadVersionUpdated(),
    ...uiActors,
    ...ticketActors,
    ...companyActors,
    ...providerActors,
    ...patrimonyActors,
    ...userActors,
    ...workflowActors,
    ...referenceActors
]


// WEBPACK FOOTER //
// ./lib/app/actors.js